var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { CLOSE_USER_MODAL, EDIT_USER } from "../../../constants";
import { useUserActions } from "../../../hooks/actions/useUserActions";
import { DispatchType, useModal } from "../../../hooks/useModal";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { WPQTModal } from "../WPQTModal";
import { UserModalContent } from "./UserModalContent";
function UserModal() {
    const { state: { userModalOpen }, } = useContext(ModalContext);
    const { modalSaving, setModalSaving, modalContentRef, closeModal, handleSuccess, } = useModal(CLOSE_USER_MODAL);
    const { editUser } = useUserActions();
    const onEditUser = (user) => __awaiter(this, void 0, void 0, function* () {
        setModalSaving(true);
        yield editUser(user, (userData) => {
            handleSuccess(EDIT_USER, userData, DispatchType.USER);
        });
        setModalSaving(false);
    });
    return (_jsx(WPQTModal, { modalOpen: userModalOpen, closeModal: closeModal, size: "xl", children: _jsx(UserModalContent, { ref: modalContentRef, modalSaving: modalSaving, editUser: onEditUser }) }));
}
export { UserModal };
